import dateFns from 'date-fns';
import fp from 'lodash/fp';
import React from 'react';
import { graphql } from 'react-apollo';
import { Link } from 'react-router-dom';
import { Button, Col, Container, Row } from 'reactstrap';
import { compose, mapProps, pure, withProps } from 'recompose';
import { routes, socials } from '../../../../constants';
import { hideIfNoEventData, notFoundIfNoEventData } from '../../../higher-order';
import { Icon } from '../../../proxy';
import './event.css';
import eventQuery from './event.gql';

const Event = ({
  data: {
    event: {
      endDate,
      image,
      location,
      name,
      socialLinks,
      startDate,
      artists
    }
  }
}) => (
    <section className='event'>
      <Container fluid>
        <h1 className='my-4'>
          {name}
          <br />
          <small className='text-muted'>
            {
              fp.join(' - ')([
                dateFns.format(
                  startDate,
                  `Do MMMM${dateFns.isSameYear(startDate, endDate) ? '' : ' YYYY'}`
                ),
                dateFns.format(endDate, 'Do MMMM YYYY')
              ])
            } | {location}
          </small>
        </h1>
        {
          socialLinks && socialLinks.length ?
            <Row className='justify-content-center socials' noGutters>
              {
                fp.map(([key, value]) => (
                  <Col key={key} xs={1}>
                    <Button
                      color='link'
                      href={value}
                      target={key !== 'envelope' ? '_blank' : undefined}
                      className={`btn-${fp.get(key)(socials)} btn-floating btn-small waves-effect waves-light`}>
                      <Icon icon={key} />
                    </Button>
                  </Col>
                ))(socialLinks)
              }
            </Row> :
            null
        }
        <Row>
          <Col className='flex-center'>
            <img className='img-fluid' src={image} alt={name} />
          </Col>
        </Row>
        {
          artists && artists.length ?
            <Row className='my-4'>
              <Col>
                <h3 className='text-center'>Artists</h3>
                <Row className='justify-content-center' noGutters>
                  {
                    fp.map(({ id, firstName, lastName, name, profileImage }) => (
                      <Col key={name} xs={12} sm={6} md={3} lg={2}>
                        <div className='testimonial-card'>
                          <Row noGutters>
                            <Col xs={12} sm={6}>
                              <div className='avatar'>
                                <Link to={routes.artist(id)}>
                                  <img
                                    className='rounded-circle img-responsive'
                                    src={profileImage}
                                    alt={name} />
                                </Link>
                              </div>
                            </Col>
                            <Col xs={12} sm={6}>
                              <Link to={routes.artist(id)} className='lead flex-center text-center'>
                                {name}
                              </Link>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    ))(artists)
                  }
                </Row>
              </Col>
            </Row> :
            null
        }
      </Container>
    </section>
  );

export default compose(
  withProps(({ match: { params: { id } } }) => ({
    id
  })),
  graphql(eventQuery),
  hideIfNoEventData('data'),
  notFoundIfNoEventData('data'),
  mapProps(({
    data: {
      event: {
        location: {
          city,
          country
        },
        socialLinks,
        website,
        ...event
      },
      ...data
    },
    ...props
  }) => ({
    ...props,
    data: {
      ...data,
      event: {
        ...event,
        location: fp.join(', ')([city, country]),
        socialLinks: fp.flow(
          fp.toPairs,
          fp.filter(([key, value]) => value && !fp.startsWith('__')(key))
        )({
          ...socialLinks,
          facebook: fp.getOr(null)('facebook.page')(socialLinks),
          globe: website
        })
      }
    }
  })),
  pure
)(Event);



// WEBPACK FOOTER //
// ./src/components/pages/app/event/event.js